<div class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md">
  <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
    <div class="trezo-card-title">
      <h5 class="!mb-0">
        Projects Analysis
      </h5>
    </div>
    <div class="trezo-card-subtitle">
      <div class="trezo-card-dropdown relative">
        <button type="button" class="trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500" (click)="toggleCardHeaderMenu()">
          <span class="inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]">
            {{ selectedTimeframe }}
            <i class="ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2"></i>
          </span>
        </button>
        @if (isCardHeaderOpen) {
          <ul class="trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none">
            <li>
              <button type="button" class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black" (click)="onTimeframeChange('Last Day')">
                Last Day
              </button>
            </li>
            <li>
              <button type="button" class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black" (click)="onTimeframeChange('Last Week')">
                Last Week
              </button>
            </li>
            <li>
              <button type="button" class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black" (click)="onTimeframeChange('Last Month')">
                Last Month
              </button>
            </li>
            <li>
              <button type="button" class="block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black" (click)="onTimeframeChange('Last Year')">
                Last Year
              </button>
            </li>
          </ul>
        }
      </div>
    </div>
  </div>
  <div class="trezo-card-content">
    <div class="-mt-[5px] -mb-[20px]">
      <div id="mp_overview_chart"></div>
    </div>
  </div>
</div>